import React from 'react';
import PropTypes from 'prop-types';

import { TabCarousel } from 'components/core/TabCarousel';
import { H2 } from 'components/core/Headline';
import { Text } from 'components/core/Text';
import { Link } from 'components/core/Link';

import podsLogo from 'assets/images/brand/portable-storage/logo-pods.png';
import packRatLogo from 'assets/images/brand/portable-storage/packRatLogo.png';
import uPackLogo from 'assets/images/brand/portable-storage/logo-upack.png';

import Tab from './Tab';
import ContentBlock from './ContentBlock';

import './portableStorageHowItWorks.scss';

/* eslint-disable max-len */
const STEPS = {
	pods: [
		{
			title: 'We Deliver',
			description: 'We deliver a PODS container to your door.'
		}, {
			title: 'You Load',
			description: 'Load it up at your own pace.'
		}, {
			title: 'We Store',
			description: 'When you\'re ready, we come pick it up and take it to a secure PODS Storage Center.'
		}, {
			title: 'We Move',
			description: 'Moving? We can transport your container wherever you need it to go.'
		}
	],
	PackRat: [
		{
			title: 'We come to you',
			description: 'No need to rent or drive a truck. We bring the storage shell to you.'
		}, {
			title: 'Pack up your stuff',
			description: 'Take 2-3 days to pack everything up or have us do it for you!'
		}, {
			title: 'We keep it safe in storage',
			description: 'We transport and store your things in a climate-controlled, secure location and can deliver it to you on demand.'
		}, {
			title: 'Moving? We deliver!',
			description: 'We can deliver your container to your new home.'
		}
	],
	upack: [
		{
			title: 'We deliver a moving trailer or Relocube',
			description: 'No need to rent or drive a truck.'
		}, {
			title: 'Load it up your way',
			description: 'You get 3 business days to load everything up.'
		}, {
			title: 'We move, store, and deliver',
			description: 'We move and store your things to a secure service center. Get it back whenever you want.'
		}, {
			title: 'Moving? We deliver!',
			description: 'We can also deliver your items to your new home.'
		}
	]
};

/* eslint-enable */

export default function PortableStorageHowItWorks({ isPSP, city, state }) {
	return (
		<div className="portable-storage-how-it-works">
			<H2>{`How Portable Storage ${
				isPSP ? '' : `in ${city}, ${state}`
			} Works`}</H2>
			<Text
				strong
				className="subheader"
				size="medium"
			>
				{`Moving and storage with popular portable storage companies ${
					isPSP ? '' : `in ${city}`
				}`}
			</Text>
			<TabCarousel
				tabs={[
					<Tab
						logo={podsLogo}
						headline="PODS"
					/>,
					<Tab
						logo={packRatLogo}
						headline="PackRat"
					/>,
					<Tab
						logo={uPackLogo}
						headline="UPack"
					/>,
				]}
				tabContent={[
					<ContentBlock
						steps={STEPS.pods}
						links={[
							<Link
								href="https://www.pods.com/partners/sparefoot"
								target="_blank"
								rel="noopener noreferrer"
							>
								view how it works at PODS.com
							</Link>,
						]}
						key="content-block-pods"
					/>,
					<ContentBlock
						steps={STEPS.PackRat}
						links={[
							<Link
								href="https://www.1800packrat.com/move-my-stuff/how-it-works"
								target="_blank"
								rel="noopener noreferrer"
							>
								view how it works at 1800packrat.com
							</Link>,
							<Link
								href="https://www.1800packrat.com/move-my-stuff/how-it-works"
								target="_blank"
								rel="noopener noreferrer"
							>
								see a video about "how it works"
							</Link>,
						]}
						key="content-block-packrat"
					/>,
					<ContentBlock
						steps={STEPS.upack}
						links={[
							<Link
								href="http://www.kqzyfj.com/click-8367506-12188931"
								target="_blank"
								rel="noopener noreferrer"
							>
								view how it works at upack.com
							</Link>,
						]}
						key="content-block-upack"
					/>,
				]}
			/>
		</div>
	);
}

PortableStorageHowItWorks.propTypes = {
	city: PropTypes.string.isRequired,
	isPSP: PropTypes.bool.isRequired,
	state: PropTypes.string.isRequired
};
